import React from "react";
import dayjs from "dayjs";
import * as qs from "query-string";
import { useHistory } from "react-router";
import { useMutation, useQuery } from "react-query";

import "./complaint.css";

import { useGet, usePost } from "app/services/http-service";
import {
  GET_COMPLAINT_TYPES,
  RAISE_COMPLAINT,
  TRANSACTION_DETAILS_BY_ID,
} from "app/api/ApiEndpoints";
import Alert from "../alert/Alert";
import useAlertConfig from "app/hooks/useAlertConfig";
import { useForm } from "react-hook-form";
import { getErrorMessage } from "app/utils";
import { Initial } from "react-initial";
import ImageLogo from "../../../images/bharat.png";

export function Complaint() {
  const { alertConfig, showSuccessAlert, showFailureAlert } = useAlertConfig(6);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  
  const { txnId, payuBillerId, payuTxnId } = qs.parse(location.search);
  const history = useHistory();
  const authToken = localStorage.getItem("tspAuthToken");
    React.useState("");
  const { data: transactionDetailsData } = useQuery(
    "transactionDetailsData",
    () =>
      useGet({
        url: `${TRANSACTION_DETAILS_BY_ID}/${txnId}`,
        token: authToken,
      }),
  );
  const {
    mutate: complaintTypeMutation,
    isSuccess: complaintTypeFetched,
    data: allTypesComplaintData,
  } = useMutation((data) => useGet(data));
  const {
    mutate: raiseComplaintMutation,
  } = useMutation((data) => usePost(data),{
    onSuccess:()=>{
      showSuccessAlert("Complaint raised successfully");
      setTimeout(() => {
            history.push("/history?tab=2");
          }, 2000);
    },
    onError:(error)=>{
     showFailureAlert(error.message ? error.message : "Something went wrong!");
    }
  });

  React.useEffect(() => {
    const body = {
      url: `${GET_COMPLAINT_TYPES}/transaction`,
      token: authToken,
    };
    complaintTypeMutation(body);
  }, [complaintTypeMutation, authToken]);

  const onSubmit = (data) =>{
    raiseComplaintMutation({
      url: `${RAISE_COMPLAINT}`,
      token: authToken,
      data: {
        payuBillerId: payuBillerId,
        complaintType: "Transaction",
        description: data.complaintMessage,
        disposition: data.complaintIssue,
        refId: payuTxnId ? payuTxnId : txnId,
      },
    });
  };

  return (
    <div>
      {alertConfig && (
        <Alert alertMessage={alertConfig.message} status={alertConfig.status} />
      )}
      <div className="container">
        <div className="transaction-panel row align-items-center justify-content-center">
          <div className="container shadow">
            <div className="row">
              <div className="col-md-4 p-0">
                <div className="card card_left bg_green p-4  border-0 h_80 ">
                  <div className="pay_info">
                    <label>Amount</label>
                    <h2>₹ {transactionDetailsData?.amount}</h2>
                  </div>
                  <div className="pay_info mb-2">
                    <label>Bharat Connect Transaction ID</label>
                    <p>{ payuTxnId ? payuTxnId : txnId }</p>
                  </div>
                  <div className="pay_info mb-2">
                    <label>Date</label>
                    <p>
                      {dayjs(transactionDetailsData?.paymentDate).format(
                        "DD/MM/YYYY",
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-8 p-0 bg-white">
                  <div className="card card_right">
                  <div className="status">
                    <div className="row">
                    <div className="col-8 d-flex justify-content-left align-items-center pb-2">
                      {
                        transactionDetailsData?.billerLogoURL ? (
                          <img
                            src={
                              transactionDetailsData?.billerLogoURL
                            }
                            alt="creditcard"
                            className="align-self-center mr-2 icon_size_default"
                          />
                        ) : (
                          <div className="initial-circle mr-1 cursor-default">
                            <Initial name={transactionDetailsData?.billerName} charCount={2} fontSize={16} fontWeight={400} height={40} width={40} />
                          </div>
                      )
                    }
                      <h6 className="font-weight-bold border-bottom">
                        {transactionDetailsData?.billerName}
                      </h6>
                    </div>
                    <div className="col-4">
                      <img src={ImageLogo} alt="logo" className="biller_img_cat" width={110}></img>
                    </div>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} noValidate>
                      <div className=" mt-2">
                        <select
                          required
                          className="form-control "
                          name="complaintIssue"
                          {...register("complaintIssue",{
                            required : true
                          })}
                        >
                          <option value="">Select issue</option>
                          {complaintTypeFetched &&
                            allTypesComplaintData &&
                            allTypesComplaintData?.map((item, index) => {
                              return (
                                <option
                                  key={index}
                                  value={index.messageDeposition}
                                >
                                  {item.messageDeposition}
                                </option>
                              );
                            })}
                        </select>
                        <span className="text-danger d-flex justify-content-start mb-2">
                            {getErrorMessage(errors, "complaintIssue", "Complaint Issue")}
                        </span>
                      </div>
                      <div>
                        <textarea
                          className="form-control"
                          name="complaintMessage"
                          placeholder="Explain your issue in details..."
                          {...register("complaintMessage")}
                        >
                        </textarea>
                         <span className="text-danger">
                            {getErrorMessage(errors, "complaintMessage", "Complaint Details")}
                          </span>
                      </div>
                      <div className="d-flex justify-content-center align-item-center mt-4">
                        <button
                          type="submit"
                          className="btn-primary btn w-100"
                        >
                          Raise Ticket
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
